import en from '../../profileContent.en';

const about = {
    ...en.about,
    metaTitle: 'Perfil',
    metaDescription:
      'Perfil liderado por el fundador de Oreste Twizeyimana: ingeniero backend con experiencia real en .NET, pensamiento sistémico influido por mecatrónica y comunicación fuerte.',
    eyebrow: 'Perfil del fundador',
    title: 'El ingeniero detrás de Oracle Consults',
    lead:
      'Esta práctica es liderada por el fundador porque el activo más fuerte detrás de ella no es una identidad de agencia amplia. Es una combinación concreta de delivery backend en producción, pensamiento sistémico y comunicación clara construida sobre trabajo real.',
    intro: [
      'La lectura más estable de la evidencia no es “desarrollador genérico”. Es ingeniero backend de producción, pensador sistémico, tutor y constructor de software ligado a problemas operativos reales.',
      'Eso importa porque la oferta de consultoría en este sitio no es marketing inventado. Es una versión comprimida de lo que el historial real de trabajo, proyectos y perfil sostiene de forma consistente.'
    ],
    quickFactsTitle: 'Vista rápida',
    quickFacts: [
      'Basado en Bydgoszcz, Polonia, y abierto a colaboración remota, híbrida y opciones con reubicación.',
      'Núcleo comercial: C#, .NET, ASP.NET Core, EF Core, SQL Server, integraciones, testing y soporte productivo.',
      'Espacio de expansión: Python, FastAPI, Flask, automatización, diagnóstico y herramientas cercanas al sistema.',
      'Diferenciadores: mecatrónica, comunicación multilingüe, tutoría y pensamiento sistémico.'
    ],
    sections: [
      {
        title: 'Lo que hace distintivo al perfil',
        paragraphs: [
          'Muchos perfiles en etapa temprana tienen una o dos señales fuertes. Este combina experiencia backend real en producción, una tesis seria ligada a un problema de negocio real, amplitud significativa en Python y una comunicación inusualmente sólida.',
          'El resultado es un consultor capaz de manejar detalle técnico sin perder el problema de negocio ni el lado humano de la entrega.'
        ]
      },
      {
        title: 'Por qué el software operativo aparece una y otra vez',
        paragraphs: [
          'El hilo personal más fuerte nace de la exposición directa a problemas de inventario y workflow en pequeños negocios. Por eso el trabajo vuelve a stock, reservas, reportes, automatización y sistemas que reducen fricción manual.',
          'Se trata más de empatía práctica que de fascinación abstracta: el software debe hacer más fiables los procesos complicados para la gente que los gestiona.'
        ]
      },
      {
        title: 'Base comercial',
        paragraphs: [
          'El centro de gravedad comercial es Oponeo.pl, donde el trabajo apunta repetidamente a APIs con ASP.NET Core, EF Core, SQL Server, integraciones de pagos y logística, tuning de rendimiento, refactorización heredada, delivery ágil, testing y soporte en producción.',
          'Esa experiencia importa porque demuestra capacidad de trabajar dentro de sistemas con tráfico real, dependencias reales y consecuencias operativas reales.'
        ]
      },
      {
        title: 'Mecatrónica y pensamiento sistémico',
        paragraphs: [
          'La ingeniería informática y la mecatrónica refuerzan una forma de pensar basada en integración, medición, fiabilidad, control, restricciones y modos de fallo.',
          'En consultoría backend, eso se traduce en mejor juicio arquitectónico, más cuidado al razonar sobre límites y mejor instinto para entender cómo se comportan los sistemas bajo presión real.'
        ]
      },
      {
        title: 'Comunicación y enseñanza',
        paragraphs: [
          'La tutoría en programación y la enseñanza de idiomas no son notas al pie. Fortalecen descomposición, claridad, paciencia y la capacidad de adaptar una explicación al público que tienes delante.',
          'Eso facilita la colaboración con clientes, founders, producto e ingeniería, que necesitan una visión compartida de lo que hace el sistema y por qué.'
        ]
      }
    ],
    valuesTitle: 'Forma de trabajar',
    values: [
      'Analítico: busco causas, dependencias, restricciones y modos de fallo en lugar de solo salida funcional.',
      'Práctico: prefiero trabajo ligado a operaciones, reportes, workflows, integraciones y utilidad visible para el negocio.',
      'Orientado a calidad: SOLID, clean architecture, testing, CI/CD y documentación forman parte de la entrega, no son decoración.',
      'Adaptable: puedo moverme entre .NET, Python, tutoría, automatización y trabajo de plataforma sin perder la misma identidad central.'
    ],
    directionTitle: 'Dirección',
    direction: [
      'Trabajo backend y de plataformas en entornos de producto técnicamente exigentes.',
      'Sistemas de negocio y plataformas operativas donde la fiabilidad importa.',
      'Herramientas en Python, automatización y trabajo backend orientado a servicios.',
      'Ingeniería backend con conciencia de seguridad y orientación al diagnóstico como ventaja de crecimiento.'
    ],
    practiceNote:
      'Consultoría backend liderada por el fundador para software operativo. Basado en Bydgoszcz, Polonia. Disponible de forma remota en Europa e internacionalmente.',
    closing:
      'El centro del perfil no es simplemente “me gusta programar”. Se parece más a esto: quiero hacer que sistemas complejos funcionen de forma fiable para personas reales.'
  };

export default about;
